// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__Ucma6","line":"LoginForm_line__rfchs","btnSubmit":"LoginForm_btnSubmit__xlLAL","title":"LoginForm_title__mbmH0"};